import { Image } from "@mantine/core";
import { useTranslation } from "next-i18next";

export function NotFound() {
  const { i18n } = useTranslation("common");

  return (
    <div
      style={{ height: "calc(100vh - 50px)", padding: 32 }}
      className="flex flex-col justify-center items-center gap-10"
    >
      <Image
        width="50vw"
        height="50vh"
        radius="xl"
        src="/img/404.svg"
        alt="Not found"
      />
      <h1 style={{ fontSize: 48, marginTop: 32 }}>{i18n.t("page404")}</h1>
    </div>
  );
}
